import { subtract } from 'ramda'
import { vue } from '@/main'
import { get } from '@/api/exam/record'
import { notify, comfirm } from '@/utils/notification'
import { ExamRoomRecord } from '@/models/exam/record'
import { Examinees } from '@/models/exam/examinees'
import { Nilable } from '@/models/helpers/common'
import { Exam } from '@/models/exam'

const sortExaminees = (a: Examinees, b: Examinees) =>
  subtract(a.sitSort, b.sitSort)

const format = (exam: ExamRoomRecord) => ({
  ...exam,
  examinees: exam.examinees.sort(sortExaminees)
})

function* createEmptyIterator() {
  yield []
}

export const fetchRecord = async (examId: string, roomId: string) => {
  if (!examId || !roomId) return null

  try {
    const data = await get(examId, roomId)
    return format(data)
  } catch (e) {
    notify('获取考生列表失败', e)
    return null
  }
}

const getRoomId = (a: ExamRoomRecord) => Number.parseInt(a.examRoom.roomId)
const sortRoom = (a: ExamRoomRecord, b: ExamRoomRecord) =>
  subtract(getRoomId(a), getRoomId(b))

export const fetchAllRecord = async (examId: string, size?: number) => {
  if (!examId) return createEmptyIterator()

  try {
    const data = await get(examId)
    const sorted = data.map(format).sort(sortRoom)

    const createIterator = function*() {
      let cur = 0
      size = size || sorted.length
      while (cur < sorted.length) {
        yield sorted.slice(cur, cur + size)
        cur += size
      }
    }
    return createIterator()
  } catch (e) {
    notify('获取考生列表失败', e)
    return createEmptyIterator()
  }
}

export const triggerPrint = async (eleId: string) => {
  await vue.$nextTick()
  try {
    await comfirm('打印下一页')
  } catch (e) {
    return false
  }
  vue.$htmlToPaper(eleId)
  return true
}

export const getSubjects = (exam: Nilable<Exam>) => {
  return exam
    ? exam.subjects.length
      ? exam.subjects.map(({ name }) => name)
      : ['签名']
    : []
}
